import React from 'react';
import { UserSettingsDto } from '../../types/settings';

interface NotificationSettingsProps {
  userSettings: UserSettingsDto;
  onSettingsUpdate: () => void;
}

export const NotificationSettings: React.FC<NotificationSettingsProps> = ({
  userSettings,
  onSettingsUpdate
}) => {
  // Prevent unused parameter warnings
  void userSettings;
  void onSettingsUpdate;

  return (
    <div className="settings-section">
      <div className="settings-section-header">
        <h2 className="settings-section-title">Notification Settings</h2>
        <p className="settings-section-description">
          Notification settings are currently being simplified. More options coming soon.
        </p>
      </div>

      {/* Email Settings section hidden as requested */}
      {/* <div className="settings-group">
        <h3 className="settings-group-title">
          <Bell size={18} style={{ marginRight: '8px' }} />
          Transactional emails (system emails)
        </h3>
        
        <div className="settings-row">
          <div className="settings-row-info">
            <div className="settings-row-label">Email Summary</div>
            <div className="settings-row-description">Get email summaries of important activity on your shared lists</div>
          </div>
          <div className="settings-row-control">
            <select
              className="settings-select"
              value={settings.emailFrequency}
              onChange={(e) => {
                const frequency = e.target.value as "off" | "daily" | "weekly";
                updateSetting('emailFrequency', frequency);
                updateSetting('emailNotificationsEnabled', frequency !== 'off');
              }}
            >
              <option value="off">Off</option>
              <option value="daily">Daily Summary</option>
              <option value="weekly">Weekly Summary</option>
            </select>
          </div>
        </div>

        {settings.emailFrequency !== 'off' && (
          <div className="settings-row">
            <div className="settings-row-info">
              <div className="settings-row-label">Email Delivery Time</div>
              <div className="settings-row-description">Your timezone for email delivery (summaries sent at 9 AM local time)</div>
            </div>
            <div className="settings-row-control">
              <select
                className="settings-select"
                value={settings.timeZone || 'UTC'}
                onChange={(e) => updateSetting('timeZone', e.target.value)}
              >
                <option value="UTC">UTC</option>
                <option value="America/New_York">Eastern Time</option>
                <option value="America/Chicago">Central Time</option>
                <option value="America/Denver">Mountain Time</option>
                <option value="America/Los_Angeles">Pacific Time</option>
                <option value="Europe/London">London</option>
                <option value="Europe/Paris">Paris</option>
                <option value="Europe/Berlin">Berlin</option>
                <option value="Asia/Tokyo">Tokyo</option>
                <option value="Asia/Shanghai">Shanghai</option>
                <option value="Australia/Sydney">Sydney</option>
              </select>
            </div>
          </div>
        )}
      </div> */}

      {/* Task Notifications */}
      {/* <div className="settings-group">
        <h3 className="settings-group-title">
          <Smartphone size={18} style={{ marginRight: '8px' }} />
          Task Notifications
        </h3>
        
        <div className="settings-row">
          <div className="settings-row-info">
            <div className="settings-row-label">Task Assignments</div>
            <div className="settings-row-description">When tasks are assigned to you</div>
          </div>
          <div className="settings-row-control">
            <button
              className={`settings-toggle ${settings.taskAssignmentNotifications ? 'active' : ''}`}
              onClick={() => updateSetting('taskAssignmentNotifications', !settings.taskAssignmentNotifications)}
            />
          </div>
        </div>

        <div className="settings-row">
          <div className="settings-row-info">
            <div className="settings-row-label">Task Completions</div>
            <div className="settings-row-description">When tasks you created or assigned are completed</div>
          </div>
          <div className="settings-row-control">
            <button
              className={`settings-toggle ${settings.taskCompletionNotifications ? 'active' : ''}`}
              onClick={() => updateSetting('taskCompletionNotifications', !settings.taskCompletionNotifications)}
            />
          </div>
        </div>

        <div className="settings-row">
          <div className="settings-row-info">
            <div className="settings-row-label">Comments</div>
            <div className="settings-row-description">When someone comments on your tasks</div>
          </div>
          <div className="settings-row-control">
            <button
              className={`settings-toggle ${settings.commentNotifications ? 'active' : ''}`}
              onClick={() => updateSetting('commentNotifications', !settings.commentNotifications)}
            />
          </div>
        </div>
      </div> */}

      {/* List Notifications */}
      {/* <div className="settings-group">
        <h3 className="settings-group-title">
          <Mail size={18} style={{ marginRight: '8px' }} />
          List & Sharing Notifications
        </h3>
        
        <div className="settings-row">
          <div className="settings-row-info">
            <div className="settings-row-label">List Sharing</div>
            <div className="settings-row-description">When lists are shared with you</div>
          </div>
          <div className="settings-row-control">
            <button
              className={`settings-toggle ${settings.listSharingNotifications ? 'active' : ''}`}
              onClick={() => updateSetting('listSharingNotifications', !settings.listSharingNotifications)}
            />
          </div>
        </div>
      </div> */}

      {/* Notification Preview */}
      {/* {(settings.emailNotificationsEnabled || settings.inAppNotificationsEnabled || settings.pushNotificationsEnabled) && (
        <div className="settings-group">
          <h3 className="settings-group-title">Notification Preview</h3>
          <div style={{ 
            padding: '16px', 
            background: '#f8fafc', 
            border: '1px solid #e2e8f0', 
            borderRadius: '6px',
            fontSize: '14px',
            color: '#6b7280'
          }}>
            <div style={{ marginBottom: '8px', fontWeight: '500', color: '#374151' }}>
              Active Notifications:
            </div>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              {settings.taskAssignmentNotifications && <li>Task assignments</li>}
              {settings.taskCompletionNotifications && <li>Task completions</li>}
              {settings.commentNotifications && <li>Comments on tasks</li>}
              {settings.listSharingNotifications && <li>List sharing</li>}
            </ul>
            {settings.emailFrequency !== 'off' && (
              <div style={{ marginTop: '8px' }}>
                Email summaries: <strong>{settings.emailFrequency === 'daily' ? 'Daily at 9 AM' : 'Weekly on Mondays at 9 AM'}</strong>
                {settings.timeZone && settings.timeZone !== 'UTC' && (
                  <span> ({settings.timeZone.replace('_', ' ')})</span>
                )}
              </div>
            )}
            {settings.pushNotificationsEnabled && (
              <div style={{ marginTop: '8px' }}>
                Push notifications: <strong>Enabled</strong>
              </div>
            )}
          </div>
        </div>
      )} */}

      {/* Save Button hidden since no settings are currently visible */}
      {/* <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginTop: '24px' }}>
        <button
          onClick={handleSave}
          disabled={isSaving}
          className="settings-button primary"
          style={{ minWidth: '120px' }}
        >
          {isSaving ? (
            'Saving...'
          ) : (
            <>
              <Save size={16} style={{ marginRight: '8px' }} />
              Save Changes
            </>
          )}
        </button>
        
        {saveMessage && (
          <span style={{ 
            color: saveMessage.includes('success') ? '#10b981' : '#ef4444',
            fontSize: '14px'
          }}>
            {saveMessage}
          </span>
        )}
      </div> */}
    </div>
  );
};
